/** The requirements of a clause list nobody assesses on a project, grouped: under a topic
 * no specialist assesses, or routed to a specialist not enrolled there. Shown in the
 * Files page's "Items with extracted clauses". */
import type { ClauseGaps as Gaps } from "../api";

const gapLines = (
  gaps: Gaps,
  topicLabel: (key: string) => string,
  agentLabel: (agent: string) => string,
): string[] => [
  ...gaps.unrouted.map(
    (g) =>
      `No specialist assesses ${g.topic === "none" ? "clauses with no topic" : topicLabel(g.topic)} yet (${g.count})`,
  ),
  ...gaps.not_enrolled.map(
    (g) => `${agentLabel(g.agent)} is not enrolled on this project (${g.count})`,
  ),
];

export const ClauseGaps = ({
  gaps,
  topicLabel,
  agentLabel,
}: {
  gaps: Gaps;
  topicLabel: (key: string) => string;
  agentLabel: (agent: string) => string;
}) => {
  const lines = gapLines(gaps, topicLabel, agentLabel);
  if (lines.length === 0) return null;
  return (
    <ul
      aria-label="Requirements nobody assesses here"
      style={{ margin: "4px 0 0", paddingLeft: 18, fontSize: 12, color: "#7a4b00" }}
    >
      {lines.map((line) => (
        <li key={line}>{line}</li>
      ))}
    </ul>
  );
};
